const FY_MONTH_LABELS = ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun'];

export interface FinancialYearMonth {
  year: number;
  month: number;
  label: string;
  slotOrder: number;
}

export const getCurrentFinancialYear = (today: Date = new Date()): number => {
  return today.getMonth() >= 6 ? today.getFullYear() : today.getFullYear() - 1;
};

export const getFinancialYearLabel = (startYear: number): string => {
  const endYearShort = String((startYear + 1) % 100).padStart(2, '0');
  return `FY ${startYear}–${endYearShort}`;
};

export const getFinancialYearRange = (startYear: number): { from: string; to: string } => ({
  from: `${startYear}-07-01`,
  to: `${startYear + 1}-06-30`,
});

export const getFinancialYearMonths = (startYear: number): FinancialYearMonth[] => {
  return Array.from({ length: 12 }, (_, i) => {
    const slotOrder = i + 1;
    const month = slotOrder <= 6 ? slotOrder + 6 : slotOrder - 6;
    const year = slotOrder <= 6 ? startYear : startYear + 1;
    return {
      year,
      month,
      label: FY_MONTH_LABELS[i],
      slotOrder,
    };
  });
};
